import React, { useCallback, memo } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Button } from 'ui-components/components/button/index';
import { openMarkAsPaidModal } from '../../../../store/orders/orders.actions';
import messages from './messages';
import style from './style.module.less';

const OrderAwaitingPayment = ({ salesOrderId }) => {
  const dispatch = useDispatch();

  const onMarkAsPaid = useCallback(() => {
    dispatch(openMarkAsPaidModal(salesOrderId));
  }, [dispatch, salesOrderId]);

  return (
    <div className={style.wrapper}>
      <div className={style.header}>
        <FormattedMessage {...messages.header} />
      </div>
      <div className={style.instructions}>
        <FormattedMessage {...messages.instructions} />
      </div>
      <div>
        <Button onClick={onMarkAsPaid} theme='primary'>
          <FormattedMessage {...messages.markAsPaid} />
        </Button>
      </div>
    </div>
  );
};

OrderAwaitingPayment.propTypes = {
  salesOrderId: PropTypes.string.isRequired,
};

export default memo(OrderAwaitingPayment);
